import { useEffect, useState } from "react";
import { Button, Modal } from "src/Components";
import ConfigModalUI from "./ConfigModalUI";
import BulkActions from "./BulkActions";
import Table from "./Table";

const AdaptationManagement = () => {
  const [isConfigOpen, setIsConfigOpen] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [accountIds, setAccountIds] = useState([] as number[]);

  const [selectedAccountIds, setSelectedAccountIds] = useState([] as number[]);

  useEffect(() => {
    if (!refreshFlag) return;
    setTimeout(() => {
      setRefreshFlag(false);
    }, 300);
  }, [refreshFlag]);

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full">
      {isConfigOpen ? (
        <Modal
          onClose={() => setIsConfigOpen(false)}
          UI={<ConfigModalUI onClose={() => setIsConfigOpen(false)} />}
          modalBoxClassName="!min-w-[350px]"
        />
      ) : (
        <></>
      )}
      <div className="w-min">
        <Button
          onClick={() => setIsConfigOpen(true)}
          text="تنظیمات تطبیق"
          variant="contained"
        />
      </div>
      <BulkActions
        refreshTable={() => setRefreshFlag(true)}
        accountIds={accountIds}
        setAccountIds={setAccountIds}
        selectedAccountIds={selectedAccountIds}
        setSelectedAccountIds={setSelectedAccountIds}
      />
     <Table accountIds={accountIds} refreshFlag={refreshFlag} setSelectedAccountIds={setSelectedAccountIds} />
    </div>
  );
};

export default AdaptationManagement;
